/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function' && typeof lazySizes !== 'object'){
  /*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var showBazaarvoice = SHOW_BAZAARVOICE;
// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    extraSortingList: 'extra-sort1-descending',
  }
};
// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: ' sold-out',
  saleClass: ' on-sale',
  soldOutLabelHtml: '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
  saleLabelHtml: '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
  tagLabelHtml: '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
  vendorHtml: '<h5 class="title-default product-item__vendor {{itemVendorHidden}}">{{itemVendorLabel}}</h5>',
  // Grid Template
  productGridItemHtml:
    '<div class="product-item js-product-item {{soldOutClass}}">' +
    '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
    '<div class="product-item__inner"><form method="post" action="/cart/add" accept-charset="UTF-8" class="form-product-small js-form-product-small" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product" tabindex="0" class=""><input type="hidden" name="utf8" value="✓" tabindex="0" class="">' +
    '<div class="product-item__select hidden">{{itemSelect}}</div>' +
    '<div class="wishlist-btn product-item__wishlist">{{itemWishlist}}</div>' +
    '<div class="product-item__images"><div class="product-item__image">{{variantImagesHtml}}</div><div class="product-item__badge">{{itemBadge}}</div></div>' +
    '<div class="product-item__content">' +
    '{{itemVendor}}' +
    '<h5 class="title-default product-item__title"><a href="{{itemUrl}}" class="link-inline">{{itemTitle}}</a></h5>' +
    '<div class="price product-item__price js-product-item-price">{{itemPrice}}</div>' +
    '<div style="display:none" data-bv-show="inline_rating" data-bv-product-id="{{itemId}}" data-bv-redirect-url="{{itemUrl}}" data-bv-seo="false"></div>' +
    '{{itemDiscount}}' +
    '{{variantsHtml}}' +
    '<div class="product-item__actions"><ul>{{itemActions}}</ul></div>' +
    '</div>' +
    '</form></div>' +
    '</div>',
  // For List View
  // List Template
  productListItemHtml:
    '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-list {{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}">' +
    '<div class="bc-sf-filter-product-item-list-col-1">' +
    '<div class="bc-sf-filter-product-item-image">' +
    '<div class="bc-sf-filter-product-item-label">{{itemLabels}}{{itemTagLabels}}</div>' +
    '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-image-link">{{itemImages}}</a>' +
    '</div>' +
    '</div>' +
    '<div class="bc-sf-filter-product-bottom">' +
    '<div class="bc-sf-filter-product-item-list-col-2">' +
    '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-title">{{itemTitle}}</a>' +
    '{{itemVendor}}' +
    '<div style="display:none" data-bv-show="inline_rating" data-bv-product-id="{{itemId}}" data-bv-redirect-url="{{itemUrl}}" data-bv-seo="false"></div>' +
    '<p class="bc-sf-filter-des">{{itemDescription}}</p>' +
    '</div>' +
    '<div class="bc-sf-filter-product-item-list-col-3">{{itemPrice}}</div>' +
    '</div>' +
    '</div>',
  // End For List View
  // Pagination Template
  previousActiveHtml: '<li class="paging__prev"><a href="{{itemUrl}}">&larr;</a></li>',
  previousDisabledHtml: '<li class="paging__prev paging__disable"><span>&larr;</span></li>',
  nextActiveHtml: '<li class="paging__next"><a href="{{itemUrl}}">&rarr;</a></li>',
  nextDisabledHtml: '<li class="paging__next paging__disable"><span>&rarr;</span></li>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li><span>{{itemTitle}}</span></li>',
  paginateHtml: '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
  // Sorting Template
  sortingHtml:
    '<label><small>' +
    Shopify.sortingTitle +
    '</small><span><span>' +
    bcSfFilterConfig.label.sorting +
    '</span></span></label><ul class="bc-sf-filter-filter-dropdown">{{sortingItems}}</ul>',
  // Show Limit Template
  showLimitHtml:
    '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
  // Breadcrumb Template
  breadcrumbHtml: '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
  breadcrumbDivider: '<span class="divider">/</span>',
  breadcrumbItemLink: '<a href="{{itemLink}}">{{itemTitle}}</a>',
  breadcrumbItemSelected: '<span>{{itemTitle}}</span>'
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  // onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;

  // Get First Variant (selected_or_first_available_variant)
  firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  
  onSale = firstVariant ? firstVariant.compare_at_price > firstVariant.price : false; // Check a product is on sale
  
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/

function sortUnique(arr) {
  arr.sort();
  var last_i;
  for (var i=0;i<arr.length;i++)
    if ((last_i = arr.lastIndexOf(arr[i])) !== i)
      arr.splice(i+1, last_i-i);
  return arr;
}

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  // Add itemReview
  if ( showBazaarvoice ) {
    itemHtml = itemHtml.replace('style="display:none"', "");
  }

  // Add data json
  var self = this;
  var itemJson = {
    id: data.id,
    title: data.title,
    handle: data.handle,
    vendor: data.vendor,
    variants: data.variants,
    url: self.buildProductItemUrl(data),
    options_with_values: data.options_with_values,
    images: data.images,
    available: data.available,
    price_min: data.price_min,
    price_max: data.price_max,
    compare_at_price_min: data.compare_at_price_min,
    compare_at_price_max: data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Product Item Select
  var selectHtml = '';
  var option = '';
  var selectVariants = data.variants;
  var selectOrFirstAvailableVariant = data.selected_or_first_available_variant.id;
  var priceHtml = '';
  var bgColorsArr = [];
  var hasPriceRange = false;
  var variantPriceArr = []
  data.variants.forEach(function(_variant, index) {
    if(_variant.available) {
      variantPriceArr.push(_variant.price)
    }
  });
  variantPriceArr = sortUnique(variantPriceArr);
  variantPriceArr.sort(function(a, b){return a-b});
  if(variantPriceArr.length > 1) {
    hasPriceRange = true;
  }

  for (var selectVariant = 0; selectVariant < selectVariants.length; selectVariant++) {
    var disabledOption = '';
    var selectedOption = '';
    var selectVariantCurrent = selectVariants[selectVariant];
    var selectVariantCompared = selectVariantCurrent.compare_at_price;
    var selectVariantPrice = selectVariantCurrent.price;
    var priceHtml = '';
    var variantId = selectVariants[selectVariant].id;
    var metaBg = '';
    var saveHtml = '';

    /* start-boost-55104 */
    var swatch_image = bcsffilter.getProductMetafield(data, variantId, 'swatch_image');
    var swatch_hex = bcsffilter.getProductMetafield(data, variantId, 'swatch_hex');
    
    if (swatch_image && swatch_image !== 'null') {
      metaBg = bcsffilter.getProductMetafield(data, variantId, 'swatch_image');
    } else if (swatch_hex && swatch_hex !== 'null') {
      metaBg = swatch_hex;
    }
    /* end-boost-55104 */

    bgColorsArr.push(metaBg);

    if (selectVariantCompared > selectVariantPrice) {
      priceHtml =
        '<del class="price__amount 111"><span class="money">' +
        bcsffilter.formatMoney(selectVariantCompared) +
        '</span></del><ins class="price__amount"><span class="money">' +
        bcsffilter.formatMoney(selectVariantPrice) +
        '</span></ins>';

      var variantSaveMoney = selectVariantCompared - selectVariantPrice;
      var variantSavePercent = 100 - parseInt((selectVariantPrice / selectVariantCompared) * 100);
      var variantPercentHtml = '(' + variantSavePercent + '%)';

      saveHtml =
        '<span>' +
        Shopify.saveString.replace('{{ money }}', bcsffilter.formatMoney(variantSaveMoney)).replace('{{ percent }}', variantPercentHtml) +
        '</span>';
    } else {
      priceHtml = '<span class="price__amount 112"><span class="money">' + bcsffilter.formatMoney(selectVariantPrice) + '</span></span>';
    }

    priceHtml = priceHtml.replace(/"/g, "'");

    if (!selectVariantCurrent.available) {
      disabledOption = 'disabled';
    }

    if (selectVariant == 0 && !hasPriceRange) {
      selectedOption = 'selected';
    }

    var option2 = '';
    if (typeof selectVariantCurrent.options[1] != 'undefined') {
      option2 = selectVariantCurrent.options[1];
    }
    var option3 = '';
    if (typeof selectVariantCurrent.options[2] != 'undefined') {
      option3 = selectVariantCurrent.options[2];
    }

    option =
      option +
      '<option value="' +
      selectVariantCurrent.id +
      '" data-save="' +
      saveHtml +
      '" data-price="' +
      priceHtml +
      '" data-option-1="' +
      selectVariantCurrent.options[0] +
      '" data-option-2="' +
      option2 +
      '" data-option-3="' +
      option3 +
      '"' +
      '" data-fb-price="' +
      (selectVariantCurrent.price / 100).toFixed(2) +
      '" data-title="' +
      selectVariantCurrent.title +
      '"' +
      disabledOption +
      ' ' +
      selectedOption +
      '>' +
      selectVariantCurrent.title +
      '</option>';
  }

  selectHtml = '<select name="id" class="product-single__variants js-product-item-select" data-title="' + data.title + '" data-product-id="' + data.id + '">' + option + '</select>';

  itemHtml = itemHtml.replace(/{{itemSelect}}/g, selectHtml);

  // Price Discount
  var priceCompared = data.selected_or_first_available_variant.compare_at_price;
  var priceNew = data.selected_or_first_available_variant.price;
  var discountHtml = '';
  var variantsHtml = '';

  if (priceCompared > priceNew) {
    var saveMoney = priceCompared - priceNew;
    var savePercent = (100 - (priceNew / priceCompared) * 100).toFixed(0);
    var percentHtml = '(' + savePercent + '%)';
    discountHtml =
      '<div class="product-item__save js-product-item-save"><span>' +
      Shopify.saveString.replace('{{ money }}', bcsffilter.formatMoney(saveMoney)).replace('{{ percent }}', percentHtml) +
      '</span></div>';
  }

  itemHtml = itemHtml.replace(/{{itemDiscount}}/g, discountHtml);

  // Product Tags and Badges
  var dateCompare = new Date();
  var days = parseInt(Shopify.dateDays);
  dateCompare.setDate(dateCompare.getDate() - days);
  var productTags = data.tags;
  var itemBadge = '';
  var itemBadgeBestseller = '';
  var itemBadgeNew = '';
  var itemBadgeSale = '';
  var itemDate = '';
  var actionsFlag = false;
  var tagColorPrefix = Shopify.tagColorPrefix;
  var tagColorPrefixNew = tagColorPrefix.replace(':', '').trim();
  var tagColorPrefixHandle = handleize(tagColorPrefixNew);
  var shopifyFilter = Shopify.filter;
  var tagPers = handleize(Shopify.tagPers);
  var tagNoPers = handleize(Shopify.tagNoPers);
  var tagNewHandle = Shopify.tagNewHandle;
  var tagNewExist = false;
  var flagPers = false;
  var flagNoPers = false;
  var currentUrl = window.location.href;
  var colorUrl = '';
  var tagColor = '';
  var colorArr = [];
  var colorTagsArr = [];
  var colorValues = [];

  for (var i = 0; i < productTags.length; i++) {
    var tag = productTags[i];
    var tagHandle = handleize(tag);

    if (Shopify.bestsellerHandle == tagHandle) {
      itemBadgeBestseller = '<span class="title-badge title-badge--up title-badge--blue">' + Shopify.bestsellerString + '</span>';

      itemBadge = itemBadgeBestseller;
    }

    if (Shopify.saleHandle == tagHandle && Shopify.tagNewHandle != tagHandle ) {
      itemBadgeSale = '<span class="title-badge title-badge--up title-badge--red">' + Shopify.saleString + '</span>';

      itemBadge = itemBadgeSale;
    }

    if (tag.indexOf(Shopify.dateTagString) !== -1) {
      itemDate = tag.replace(Shopify.dateTagString, '');
    }

    if (tagHandle == Shopify.viewDetailsHandle) {
      actionsFlag = true;
    }

    if (tag.indexOf(Shopify.tagColorPrefix) !== -1 && shopifyFilter != undefined) {
      var tagColorNew = tag.replace(tagColorPrefix, '').trim();
      var tagColorNewHandle = handleize(tagColorNew);
      colorTagsArr.push(tagColorNewHandle);
    }

    if (tagPers == tagHandle) {
      flagPers = true;
    } else if (tagNoPers == tagHandle) {
      flagNoPers = true;
    }

    if (tagNewHandle == tagHandle) {
      tagNewExist = true;
    }
  }

  if (currentUrl.indexOf(tagColorPrefixHandle) !== -1 && colorTagsArr.length > 0) {
    var splitter = '&pf_t_' + tagColorPrefixHandle + '=' + tagColorPrefixHandle;
    colorUrl = currentUrl;

    if (colorUrl.indexOf('?_=pf') !== -1 || colorUrl.indexOf('&_=pf') !== -1) {
      var colorUrlSplitter = '';
      if (colorUrl.indexOf('?_=pf') !== -1) {
        colorUrlSplitter = '?_=pf';
      } else if (colorUrl.indexOf('&_=pf') !== -1) {
        colorUrlSplitter = '&_=pf';
      }

      colorUrl = colorUrl
        .replace(/%3A/g, '')
        .replace(/%20/g, '')
        .split(colorUrlSplitter)[1]
        .split('&pf_t_');

      for (var i = 0; i < colorUrl.length; i++) {
        var urlElementHandle = handleize(colorUrl[i]);
        var newSplitter = tagColorPrefixHandle + '-' + tagColorPrefixHandle;

        if (urlElementHandle.indexOf(newSplitter) !== -1) {
          var urlElementNew = urlElementHandle.replace(newSplitter, '');
          colorArr.push(urlElementNew);
        }
      }
    }
  }

  if (colorTagsArr.length > 0 && colorArr.length > 0) {
    var colorArrFlag = false;
    for (var i = 0; i < colorTagsArr.length; i++) {
      colorTagsArr[i];

      for (var y = 0; y < colorArr.length; y++) {
        colorArr[y];

        if (colorTagsArr[i] == colorArr[y]) {
          tagColor = colorTagsArr[i];
          colorArrFlag = true;
          break;
        }
      }

      if (colorArrFlag) {
        break;
      }
    }
  }

  if (tagColor != '') {
    var keys = Object.keys(shopifyFilter);
    var keyIdx = 0;

    for (var i = 0; i < keys.length; i++) {
      keys[i];

      if (tagColor == keys[i]) {
        keyIdx = i;
        colorValues = Shopify.filter[Object.keys(Shopify.filter)[keyIdx]];

        break;
      }
    }
  }

  // Date
  if (tagNewExist == true) {
    itemBadgeNew = '<span class="title-badge title-badge--up title-badge--blue">' + Shopify.badgeNew + '</span>';

    itemBadge = itemBadgeNew;
  }

  // if (itemDate != '' && tagNewExist == false && itemBadge === '') {
  //   var itemDateFormatted = new Date(itemDate);

  //   if (itemDateFormatted > dateCompare) {
  //     itemBadgeNew = '<span class="title-badge title-badge--up title-badge--blue">' + Shopify.badgeNew + '</span>';

  //     itemBadge = itemBadgeNew;
  //   }
  // }

  // Product Actions
  var itemActions = '';
  var attrDisabled = '';
  var firstVariant = null;
  var foundFirstVariant = false;
  for (var i = 0; i < data.variants.length; i++) {
    if(data.variants[i].available && !foundFirstVariant) {
      firstVariant = data.variants[i];
      foundFirstVariant = true;
    }
  }

  var productAllQty = firstVariant.inventory_quantity;
  if (itemBadge === '' && productAllQty > 0 && productAllQty <= Shopify.almostGoneNumber) {
    itemBadge = '<span class="title-badge title-badge--up title-badge--red">' + Shopify.almostGoneText + '</span>';
  }

  // Almost gone
  itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadge);

  if (!firstVariant.available || variantPriceArr.length > 1) {
    attrDisabled = 'disabled';
  }

  if (actionsFlag) {
    itemActions =
      '<li><a href="' +
      data.url +
      '?variant=' +
      firstVariant.id +
      '" class="btn btn--medium-secondary btn--block js-product-item-details">' +
      Shopify.btnViewDetails +
      '</a></li>';
  } else if (flagPers && flagNoPers) {
    itemActions =
      '<li><a href="' +
      data.url +
      '" class="btn btn--lightblue btn--medium-secondary btn--block js-product-item-view" data-popup="#popup-product" data-class="expanded">' +
      Shopify.btnQuickView +
      '</a></li><li><a href="' +
      data.url +
      '" class="btn btn--lightbeige btn--medium-secondary btn--block js-product-item-personalization">' +
      Shopify.btnPers +
      '</a></li>';
  } else if (flagPers) {
    itemActions =
      '<li><a href="' +
      data.url +
      '" class="btn btn--lightbeige btn--medium-secondary btn--block js-product-item-personalization">' +
      Shopify.btnPers +
      '</a></li>';
  } else {
    if ((data.options_with_values.length == 1 && options != '') || data.variants.length == 1) {
      itemActions =
        '<li><a href="' +
        data.url +
        '" class="btn btn--lightblue btn--medium-secondary btn--block js-product-item-view" data-popup="#popup-product" data-class="expanded">' +
        Shopify.btnQuickView +
        '</a></li><li class="product-item__actions-add"><input type="submit" value="' +
        Shopify.btnAddToBag +
        '" class="form__btn btn btn--medium-secondary btn--block js-product-item-btn" ' +
        attrDisabled +
        '></li><li class="product-item__actions-details"><a href="' +
        data.url +
        '?variant=' +
        firstVariant.id +
        '" class="btn btn--medium-secondary btn--block js-product-item-details">' +
        Shopify.btnViewDetails +
        '</a></li>';
    } else {
      itemActions =
        '<li><a href="' +
        data.url +
        '" class="btn btn--lightblue btn--medium-secondary btn--block js-product-item-view" data-popup="#popup-product" data-class="expanded">' +
        Shopify.btnQuickView +
        '</a></li><li><a href="' +
        data.url +
        '?variant=' +
        firstVariant.id +
        '" class="btn btn--medium-secondary btn--block js-product-item-details">' +
        Shopify.btnViewDetails +
        '</a></li>';
    }
  }

  itemHtml = itemHtml.replace(/{{itemActions}}/g, itemActions);

  // Color Swatches and Images
  var optionValues = data.options_with_values;
  var options = '';
  var radioOptionHtml = '';
  var idxColor = '';
  var colorsArr = [];
  var variantImagesHtml = '';
  var colorHexFromMeta = data.metafields.reduce((res, curr) => {
    if(curr.namespace == 'global' && curr.key == 'swatch_hex') {
      res = [...res, {'value': curr.value, 'id': curr.id}];
    }
    return res;
  },[]);
  var swatchImageFromMeta = data.metafields.reduce((res, curr) => {
    if(curr.namespace == 'global' && curr.key == 'swatch_image') {
      res = [...res, {'value': curr.value, 'id': curr.id}];
    }
    return res;
  },[]);

  for (var i = 0; i < optionValues.length; i++) {
    var optionHandle = handleize(optionValues[i].name);

    if (optionHandle == Shopify.variantColorHandle) {
      options = optionValues[i].values;
      idxColor = i;
    }
  }

  if (this.isSearchPage()) {
    var searchTerm = this.getSearchTerm();
    var variant = data.variants.find(function(e){ return e.sku == searchTerm;});
  }
  
  if (options != '') {
    var optionIdx = idxColor + 1;
    var filteredFlag = true;
    var isFirstNotOOO = false;

    
    for (var i = 0; i < options.length; i++) {
      var variantTitle = options[i].title;
      var variantTitleHandle = handleize(variantTitle);
      var checkedHtml = '';
      var filteredClass = '';
      var bgRadioColor = '#fff';
      var not_ooo = true;
      var colorHex = colorHexFromMeta.find(e => e.id == data.variants[i].id) || {'id': 'undefined', 'value': 'undefined'};
      var swatchImage = swatchImageFromMeta.find(e => e.id == data.variants[i].id) || {'id': 'undefined', 'value': 'undefined'};

      if (colorValues != '' && filteredFlag) {
        for (var x = 0; x < colorValues.length; x++) {
          var colorValue = colorValues[x];

          if (colorValue == variantTitleHandle) {
            filteredClass = ' class="js-radio-filtered"';
            filteredFlag = false;
          }
        }
      }

      if (bgColorsArr[i] != '') {
        if (bgColorsArr[i].indexOf('#') !== -1) {
          bgRadioColor = bgColorsArr[i];
        } else {
          bgRadioColor = 'url(' + bcsffilter.fileUrl.split('files/')[0] + 'files/' + bgColorsArr[i] + ')';
        }
      }

      if(optionValues.length == 1) {
        var this_variant = data.variants.find(function(e){ return e.option1 == variantTitle;});
        not_ooo = this_variant.available;
      }

      if(not_ooo) {
        if (this.isSearchPage() && typeof variant != 'undefined') {
          if (variantTitle == variant.title) {
            checkedHtml = 'checked';
          }
        } else {
          if (!isFirstNotOOO && !hasPriceRange) {
            checkedHtml = 'checked';
            isFirstNotOOO = true;
          }
        }

        

        radioOptionHtml =
          radioOptionHtml +
          '<div><div class="radio-color radio-color--mobile js-radio-color-item"><input type="radio" name="radios-collection-' +
          index +
          '" id="radios-collection-' +
          variantTitleHandle +
          '-' +
          index +
          '-' +
          i +
          '" value="' +
          variantTitleHandle +
          '" data-option="' +
          optionIdx +
          '" data-value="' +
          variantTitle +
          '" data-index="' +
          i +
          '" ' +
          checkedHtml +
          ' data-image-target="' +
          data.handle +
          '-' +
          index +
          '"' +
          filteredClass +
          '><label for="radios-collection-' +
          variantTitleHandle +
          '-' +
          index +
          '-' +
          i +
          '"' +
          filteredClass +
          '><span style="background-color:' +
          colorHex['value'] +
          '; background-image: url(' + bcsffilter.fileUrl.split('files/')[0] + 'files/' + swatchImage['value'] + ');"></span></label></div></div>';
      }
    }

    isFirstNotOOO = false;
    for (var i = 0; i < data.variants.length; i++) {
      if(data.variants[i].available) {
        var optionColor = data.variants[i].options[idxColor];
        var classExpanded = '';
        var variantImageHtml = '';
        var emptyVariantImage = '';

        if (colorsArr.indexOf(optionColor) <= -1) {
          colorsArr.push(optionColor);

          if (this.isSearchPage() && typeof variant != 'undefined') {
            if (data.variants[i].id == variant.id) {
              classExpanded = 'expanded';
            }
          } else {
            if (!isFirstNotOOO) {
              classExpanded = 'expanded';
              isFirstNotOOO = true;
            }
          }

          if (data.variants[i].image != null) {
            var srcSet = bcsffilter.optimizeImage(data.variants[i].image, '125x') + ' 125w,';
            srcSet += bcsffilter.optimizeImage(data.variants[i].image, '250x') + ' 250w,';
            srcSet += bcsffilter.optimizeImage(data.variants[i].image, '500x') + ' 500w';
            variantImageHtml = '<img class="lazyload mCS_img_loaded " data-src="' + bcsffilter.optimizeImage(data.variants[i].image, '500x') + '" ' +
                					' data-srcset="' + srcSet + '" data-aspectratio="1.0" data-sizes="auto" />';
//             variantImageHtml = '<img src="' + data.variants[i].image + '">';
          } else {
            emptyVariantImage = ' no-image';
          }

          variantImagesHtml =
            variantImagesHtml +
            '<figure class="' +
            classExpanded +
            emptyVariantImage +
            '" data-variant-image="' +
            data.handle +
            '-' +
            index +
            '" data-index="' + i + '"><a href="' +
            data.url +
            '?variant=' +
            data.variants[i].id +
            '"></a>' +
            variantImageHtml +
            '</figure>';
        }
      }
    }
  } else {
    var srcSet = bcsffilter.optimizeImage(data.featured_image.src, '125x') + ' 125w,';
    srcSet += bcsffilter.optimizeImage(data.featured_image.src, '250x') + ' 250w,';
    srcSet += bcsffilter.optimizeImage(data.featured_image.src, '500x') + ' 500w';
    var imageHtml = '<img class="lazyload mCS_img_loaded " data-src="' + bcsffilter.optimizeImage(data.featured_image.src, '500x') + '" ' +
   	 					' data-srcset="' + srcSet + '" data-aspectratio="1.0" data-sizes="auto" />';
    if (data.images.length > 1) {
      var srcSet = bcsffilter.optimizeImage(data.images[1].src, '125x') + ' 125w,';
      srcSet += bcsffilter.optimizeImage(data.images[1].src, '250x') + ' 250w,';
      srcSet += bcsffilter.optimizeImage(data.images[1].src, '500x') + ' 500w';
      var secondImageHtml = '<img class="lazyload mCS_img_loaded " data-src="' + bcsffilter.optimizeImage(data.images[1].src, '500x') + '" ' +
   	 					' data-srcset="' + srcSet + '" data-aspectratio="1.0" data-sizes="auto" />';
      variantImagesHtml = '<figure class="hover-alt"><a href="' + data.url + '"></a>' +
        					imageHtml + '</figure><figure class="hover-alt"><a href="' + data.url + '"></a>' + 
        					secondImageHtml + '</figure>';
    } else if (data.images.length == 1) {
      variantImagesHtml = '<figure class="expanded"><a href="' + data.url + '"></a>' + imageHtml + '</figure>';
    } else {
      variantImagesHtml = '<figure class="no-image"><a href="' + data.url + '"></a></figure>';
    }
    
//     if (data.images.length > 1) {
//       variantImagesHtml =
//         '<figure class="hover-alt"><a href="' +
//         data.url +
//         '"></a><img src="' +
//         data.featured_image.src +
//         '"></figure><figure class="hover-alt"><a href="' +
//         data.url +
//         '"></a><img src="' +
//         data.images[1].src +
//         '"></figure>';
//     } else if (data.images.length == 1) {
//       variantImagesHtml = '<figure class="expanded"><a href="' + data.url + '"></a><img src="' + data.featured_image.src + '"></figure>';
//     } else {
//       variantImagesHtml = '<figure class="no-image"><a href="' + data.url + '"></a></figure>';
//     }
  }

  if (radioOptionHtml != '') {
    variantsHtml =
      '<div class="product-item__variants"><div class="list-radios-colors js-radios-colors js-radios-slider">' +
      radioOptionHtml +
      '</div></div>';
  }

  itemHtml = itemHtml.replace(/{{variantsHtml}}/g, variantsHtml);
  itemHtml = itemHtml.replace(/{{variantImagesHtml}}/g, variantImagesHtml);

  /*Wishlist*/
  var itemWishlistHtml = "<!-- include 'wishlist-button-collection' with '" + data.id + "' -->";
  itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);

  if (data.tags.length > 0) {
    let _tag_piece = '';
    try {
      if ( bcSfFilterMainConfig.general.show_vendor_overrides ) {
        data.tags.forEach(function(_tag){
          if(_tag.includes('designer_description')) {
            _tag_piece = _tag.split('designer_description:');
            _tag_piece = _tag_piece[1];
          }
        });
      }
    } catch ( e ) {
      // fallback to base vendor
    }

    if(_tag_piece != '') {
      switch(_tag_piece) {
        case "Lenox":
        case "Dansk":
        case "Reed & Barton":
          itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
          //itemHtml = itemHtml.replace(/{{itemVendorHidden}}/g, 'hidden');
          break;
        default:
          itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, _tag_piece);
          //itemHtml = itemHtml.replace(/{{itemVendorHidden}}/g, '');
          break;
      }
    } else {
      itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
      //itemHtml = itemHtml.replace(/{{itemVendorHidden}}/g, 'hidden');
    }
  } else {
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    //itemHtml = itemHtml.replace(/{{itemVendorHidden}}/g, 'hidden');
  }

  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }  
  
  var onSale = firstVariant ? firstVariant.compare_at_price > firstVariant.price : false; // Check a product is on sale
  
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription =
    itemDescription.split(' ').length > 40
      ? itemDescription
          .split(' ')
          .splice(0, 40)
          .join(' ') + '...'
      : itemDescription
          .split(' ')
          .splice(0, 40)
          .join(' ');
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  if ( showBazaarvoice ) {
    itemHtml = itemHtml.replace('style="display:none"', "");
  }
  return itemHtml;
  // End For List View
};

/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function handleize(str = '') {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace('_', '-');
}

function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = '';
  // Build Main Image
  var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  html += '<img src="' + thumbUrl + '" class="bc-sf-filter-product-item-main-image" />';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl = images.length > 1 ? bcsffilter.optimizeImage(images[1]['src']) : thumbUrl;
    html += '<img src="' + flipImageUrl + '" class="bc-sf-filter-product-item-flip-image" />';
  }
  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_price) {
    var hasPriceRange = false;
    var variantPriceArr = []
    
    data.variants.forEach(function(_variant, index) {
      if(_variant.available) {
        variantPriceArr.push(_variant.price)
      }
    });
    variantPriceArr = sortUnique(variantPriceArr);
    variantPriceArr.sort(function(a, b){return a-b});
    if(variantPriceArr.length > 1) {
      hasPriceRange = true;
    }

    html = '';
    if (onSale) {
      html += '<del class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.compare_at_price_min) + '</span></del> ';
      if (hasPriceRange) {
        html += '<ins class="price__amount"><span class="money">' + bcsffilter.formatMoney(variantPriceArr[0]) + ' - ' + bcsffilter.formatMoney(variantPriceArr[variantPriceArr.length - 1]) + '</span></ins>';
      } else {
        html += '<ins class="price__amount"><span class="money">' + bcsffilter.formatMoney(variantPriceArr[0]) + '</span></ins>';
      }
    } else {
      if (hasPriceRange) {
        html += '<span class="price__amount"><span class="money">' + bcsffilter.formatMoney(variantPriceArr[0]) + ' - ' + bcsffilter.formatMoney(variantPriceArr[variantPriceArr.length - 1]) + '</span></span>';
      } else {
        html += '<span class="price__amount"><span class="money">' + bcsffilter.formatMoney(variantPriceArr[0]) + '</span></span>';
      }
    }
    html += '';
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf('pfs:label') !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf('pfs:label') !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Result Items
  var $resultsElement = jQ('.js-search-count-results');
  if ($resultsElement.length) {
    $resultsElement.find('small').text(totalProduct);
  }

  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = currentPage > 1 ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = currentPage < totalPage ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += pageArr[iPage] == currentPage ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var paramSort = this.queryParams.sort || '';
      // Build content
      var sortingItemsHtml = '';
      var sortLabel = '';
      for (var k in sortingArr) {
        if (k != '') {
          activeClass = '';
          var sortLabelHandle = 'sorting_' + k.replace(/\-/g, '_');
          var sortLabel = bcSfFilterConfig.label[sortLabelHandle];

          if (paramSort == k) {
            activeClass = 'active';
          }

          if (k == 'created-descending' || k == 'created-ascending') {
            sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortLabel + '</a></li>';
          } else {
            sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
          }
        }
      }

      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ('.bc-sf-filter-custom-sorting').html(html);
      if (jQ('.bc-sf-filter-custom-sorting').hasClass('bc-sf-filter-sort-active')) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
      }

      var labelSort = '';
      if (paramSort.length > 0) {
        var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
        labelSort = bcSfFilterConfig.label[labelHandle];
      } else {
        labelSort = bcSfFilterConfig.label.sorting;
      }

      jQ('.bc-sf-filter-custom-sorting label span span').text(labelSort);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  jQ('.bc-sf-filter-filter-dropdown a').click(function(e) {
    e.preventDefault();
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
  });

  jQ('.bc-sf-filter-custom-sorting > label').click(function() {
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown')
        .toggle()
        .parent()
        .toggleClass('bc-sf-filter-sort-active');
      jQ('#bc-sf-filter-tree').hide();
    }
  });

  jQ(this.getSelector('filterTreeMobileButton')).click(function() {
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
  });
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink('display', 'list', 'grid') +
    '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink('display', 'grid', 'list') +
    '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this)
      .parent()
      .children()
      .removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  });
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink
          .replace(/{{itemLink}}/g, '/collections/' + colInfo.handle)
          .replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += ' {{breadcrumbDivider}} ';
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
        /{{itemTitle}}/g,
        this.getSettingValue('label.defaultCollectionHeader')
      );
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml);
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image')
    .load(function() {
      var imageContainer = jQ(this).parent();
      imageContainer.css('width', '100%').css('height', jQ(this).height());
    })
    .each(function() {
      if (this.complete) jQ(this).load();
    });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  /* start-initialize-bc-al */
  var self = this;
  var alEnable = true;
  if (self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != '') {
    alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
  }
  if (alEnable === true && typeof BCActionList !== 'undefined') {
    if (typeof bcActionList === 'undefined') {
      bcActionList = new BCActionList();
    } else {
      if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
        bcActionList.initFlag = false;
        bcActionList.alInit(bcSfFilterParams, bcAlParams);
      } else {
        bcActionList.alInit();
      }
    }
  }
  /* end-initialize-bc-al */
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init);
  }
  // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  matchHeightImage();
  jQ(window).resize(function() {
    matchHeightImage();
  });

  jQ('body')
    .find('.bc-sf-filter-skeleton-button')
    .remove();

  // Prevent double tap on iOS
  this.isMobile() &&
    jQ('.bc-sf-filter-product-item')
      .find('a')
      .on('touchstart', function() {
        isScrolling = !1;
      })
      .on('touchmove', function() {
        isScrolling = !0;
      })
      .on('touchend', function() {
        isScrolling || (window.location = jQ(this).attr('href'));
      });

  // Fix image not loaded on mobile
  (this.isMobile() || null != navigator.userAgent.match(/iPad/i)) &&
    (setTimeout(function() {
      jQ('.bc-sf-filter-product-item-image img').each(function() {
        var a = jQ(this).attr('src') + '3';
        jQ(this).attr('src', a);
      });
    }, 200),
    setTimeout(function() {
      jQ('.bc-sf-filter-product-item-image img').each(function() {
        var a = jQ(this).attr('src') + '3';
        jQ(this).attr('src', a);
      });
    }, 2e3));

  /* Radios Slider */
  if (jQ('.js-radios-slider').length) {
    jQuery(window).trigger('load-products');
  }

  /* Counter Items */
  var $selectedItem = jQ('.bc-sf-filter-selected-items .selected-item');
  var $block = jQ('.bc-sf-filter-option-block');

  if ($selectedItem.length) {
    $block.each(function() {
      var $this = jQ(this);
      var $title = $this.find('.bc-sf-filter-block-title h3');
      var blockTitle = $title.find('span').text();
      var counter = 0;
      var counterHtml = '';

      $selectedItem.each(function() {
        var selectedText = jQ(this)
          .find('.selected-type span')
          .text();

        if (blockTitle == selectedText) {
          counter = counter + 1;
        }
      });

      if (counter != 0) {
        var counterHtml = '<small>(' + counter + ')</small>';
        if ($title.find('small').length) {
          $title.find('small').remove();
        }

        $title.append(counterHtml);
      } else if (counter == 0 && $title.find('small').length) {
        $title.find('small').remove();
      }
    });
  }

  /* Filter Show */
  var $filter = jQ('.js-filter');

  if ($filter.length && $filter.hasClass('active')) {
    var filterData = $filter.attr('data-filter-dropdown');

    $filter.find('.bc-sf-filter-option-block[data-title="' + filterData + '"]').addClass('expanded not-transition');
  }

  // Click Products
  var $filteredInput = jQ('.js-radio-color-item input.js-radio-filtered');
  if ($filteredInput.length) {
    $filteredInput.trigger('click');
  }

  // Sort
  var $sort = jQ('.js-sort');
  if ($sort.length && $sort.hasClass('expanded')) {
    $sort.removeClass('expanded');
  }
};

// Build Default layout
function buildDefaultLink(a, b) {
  var c = window.location.href.split('?')[0];
  return (c += '?' + a + '=' + b);
}
BCSfFilter.prototype.buildDefaultElements = function(a) {
  if (bcSfFilterConfig.general.hasOwnProperty('collection_count') && jQ('#bc-sf-filter-bottom-pagination').length > 0) {
    var b = bcSfFilterConfig.general.collection_count,
      c = parseInt(this.queryParams.page),
      d = Math.ceil(b / this.queryParams.limit);
    if (1 == d) return jQ(this.selector.pagination).html(''), !1;
    if ('default' == this.getSettingValue('general.paginationType')) {
      var e = bcSfFilterTemplate.paginateHtml,
        f = '';
      (f =
        c > 1
          ? bcSfFilterTemplate.hasOwnProperty('previousActiveHtml')
            ? bcSfFilterTemplate.previousActiveHtml
            : bcSfFilterTemplate.previousHtml
          : bcSfFilterTemplate.hasOwnProperty('previousDisabledHtml')
          ? bcSfFilterTemplate.previousDisabledHtml
          : ''),
        (f = f.replace(/{{itemUrl}}/g, buildDefaultLink('page', c - 1))),
        (e = e.replace(/{{previous}}/g, f));
      var g = '';
      (g =
        c < d
          ? bcSfFilterTemplate.hasOwnProperty('nextActiveHtml')
            ? bcSfFilterTemplate.nextActiveHtml
            : bcSfFilterTemplate.nextHtml
          : bcSfFilterTemplate.hasOwnProperty('nextDisabledHtml')
          ? bcSfFilterTemplate.nextDisabledHtml
          : ''),
        (g = g.replace(/{{itemUrl}}/g, buildDefaultLink('page', c + 1))),
        (e = e.replace(/{{next}}/g, g));
      for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i);
      c - 4 > 0 && h.unshift('...'), c - 4 >= 0 && h.unshift(1), h.push(c);
      for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k);
      c + 3 < d && j.push('...'), c + 3 <= d && j.push(d);
      for (var l = '', m = h.concat(j), n = 0; n < m.length; n++)
        '...' == m[n]
          ? (l += bcSfFilterTemplate.pageItemRemainHtml)
          : (l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml),
          (l = l.replace(/{{itemTitle}}/g, m[n])),
          (l = l.replace(/{{itemUrl}}/g, buildDefaultLink('page', m[n])));
      (e = e.replace(/{{pageItems}}/g, l)), jQ(this.selector.pagination).html(e);
    }
  }
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml') && jQ(this.selector.topSorting).length > 0) {
    jQ(this.selector.topSorting).html('');
    var o = this.getSortingList();
    if (o) {
      var p = '';
      for (var q in o) p += '<option value="' + q + '">' + o[q] + '</option>';
      var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
      jQ(this.selector.topSorting).html(r);
      var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting;
      jQ(this.selector.topSorting + ' select').val(s),
        jQ(this.selector.topSorting + ' select').change(function(a) {
          window.location.href = buildDefaultLink('sort_by', jQ(this).val());
        });
    }
  }
};

BCSfFilter.prototype.prepareProductData = function(data) {
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]['images'] = data[k]['images_info'];
    if (data[k]['images'].length > 0) {
      data[k]['featured_image'] = data[k]['images'][0];
    } else {
      data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 };
    }
    data[k]['url'] = '/products/' + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]['options_with_values'].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]['options_with_values'][i]['name']);
    }
    data[k]['options'] = optionsArr;
    if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {
      var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();
      function updateMultiCurrencyPrice(oldPrice, newPrice) {
        if (typeof newPrice != 'undefined') {
          return newPrice;
        }
        return oldPrice;
      }
      data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);
      data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);
      data[k].compare_at_price_min = updateMultiCurrencyPrice(
        data[k].compare_at_price_min,
        data[k]['compare_at_price_min_' + currentCurrency]
      );
      data[k].compare_at_price_max = updateMultiCurrencyPrice(
        data[k].compare_at_price_max,
        data[k]['compare_at_price_max_' + currentCurrency]
      );
    }
    (data[k]['price_min'] *= 100),
      (data[k]['price_max'] *= 100),
      (data[k]['compare_at_price_min'] *= 100),
      (data[k]['compare_at_price_max'] *= 100);
    data[k]['price'] = data[k]['price_min'];
    data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
    data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];
    var firstVariant = data[k]['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      var countVariants = data[k]['variants'].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]['variants'][i].available) {
          firstVariant = data[k]['variants'][i];
          break;
        }
      }
    }
    data[k]['selected_or_first_available_variant'] = firstVariant;
    var countVariants = data[k]['variants'].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]['variants'][i]['options'] = variantOptionArr;
      }
      data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
    }
    data[k]['description'] = data[k]['content'] = data[k]['body_html'];
    if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {
      data[k].tags = data[k]['original_tags'].slice(0);
    }
  }
  return data;
};

// Scroll to previous position when going back from product page
BCSfFilter.prototype.scrollBackPositionHistoryBack = function() {
    // Get setting
    var enableKeepScrollbackPosition = this.getSettingValue('general.enableKeepScrollbackPosition');
    if (enableKeepScrollbackPosition) {
        // Get the product grid item
        var productItemSelector = jQ(this.selector.products).children();
        if (this.isAdvancedPaginationType() && productItemSelector.length > 0) {
            // Get current page
            var page = parseInt(this.queryParams.page);
            // Add id & data-page attribute to item
            productItemSelector.each(function() {
                if (typeof jQ(this).attr('id') == 'undefined') {
                    var itemLink = '';
                    jQ(this).find('a').each(function() {
                        var link = jQ(this).attr('href') || '';
                        if (link.length > 0 && link.match(/(?:\/products\/)(?:[^\?]*)/)) {
                            itemLink = link.split('?')[0];
                            return false;
                        }
                    });
                    var idItem = itemLink.toString().replace(/^_+|_+$|\//g, '') + '-' + page;
                    jQ(this).attr('id', idItem);
                }
                if (typeof jQ(this).data('page') == 'undefined') {
                    jQ(this).attr('data-page', page);
                }
            });
            if (this.isMobile()) {
                // Change params on the address bar when click to item
                var isScrolling = false;
                // Change params on the address bar when click to item ( Ignore if scrolling action )
                productItemSelector.on('touchstart', function() {
                    isScrolling = false;
                }).on('touchmove', function(e) {
                    isScrolling = true;
                }).on('touchend', function(e) {
                    var productId = jQ(this).attr('id') || false;
                    if (!isScrolling && productId) {
                        var urlW = new URL(window.location.href),
                            page = jQ(this).data('page') || 1,
                            stage = {
                                productId: productId,
                                page: page
                            };
                        if (urlW.searchParams.get('page') !== null) urlW.searchParams.delete('page');
                        if (parseInt(page) > 1) urlW.searchParams.append('page', page);
                        // Set state before redirect to product page
                        window.history.replaceState(stage, '', urlW.toString().replace(/\+/g, '%20'));
                    }
                });
            } else {
                // Change params on the address bar when click to item
                productItemSelector.click(function(e) {
                    var productId = jQ(this).attr('id') || false;
                    if (productId) {
                        var urlW = new URL(window.location.href),
                            page = jQ(this).data('page') || 1,
                            stage = {
                                productId: productId,
                                page: page
                            };
                        if (urlW.searchParams.get('page') !== null) urlW.searchParams.delete('page');
                        if (parseInt(page) > 1) urlW.searchParams.append('page', page);
                        // Set state before redirect to product page
                        window.history.replaceState(stage, '', urlW.toString().replace(/\+/g, '%20'));
                    }
                    
                });
            }
            // Turn off scroll default  of browser
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            if (history.state !== null && history.state.hasOwnProperty('productId')) {
                var urlW = new URL(window.location.href),
                    itemId = history.state.productId;
                if (itemId !== null) {
                    window.history.replaceState('', '', urlW.toString().replace(/\+/g, '%20'));
                  	jQ('html, body').animate({ scrollTop: jQ('#' + itemId).offset().top - jQ('#header').height() - 100 }, 0);
                }
            }
        }
    }
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
